import React from 'react';
interface StickyMobileCTAProps {
  onRegisterClick: () => void;
}
export function StickyMobileCTA({
  onRegisterClick
}: StickyMobileCTAProps) {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-brand-navy border-t border-brand-gold/30 p-3 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-189">
      <button onClick={onRegisterClick} className="w-full bg-brand-gold hover:bg-[#d4b455] text-black font-display font-bold uppercase text-lg py-3 px-4 rounded-full flex items-center justify-center gap-2 transition-all active:scale-95" data-id="element-190">
        Secure Ticket Now <span className="text-xl" data-id="element-191">→</span>
      </button>
    </div>;
}